import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * SOS Service
 * Handles all SOS emergency-related API calls
 */
const sosService = {
  getAllSOS: async () => {
    const response = await apiClient.post(API_ENDPOINTS.SOS.GET_ALL);
    return response.data;
  },

  getAllSOSEmergency: async () => {
    const response = await apiClient.post(API_ENDPOINTS.SOS.GET_EMERGENCY);
    return response.data;
  },

  updateSOS: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SOS.UPDATE, data);
    return response.data;
  },

  getTimeline: async (userSOSId) => (await apiClient.post(API_ENDPOINTS.SOS.TIMELINE, { userSOSId })).data,
  assign: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.ASSIGN, data)).data,
  reallocate: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.REALLOCATE, data)).data,
  cancel: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.CANCEL, data)).data,
  complete: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.COMPLETE, data)).data,
  getSettings: async () => (await apiClient.post(API_ENDPOINTS.SOS.SETTINGS, {})).data,
  saveSettings: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.SAVE_SETTINGS, data)).data,
  getPartnerConfig: async () => (await apiClient.post(API_ENDPOINTS.SOS.PARTNER_CONFIG, {})).data,
  savePartnerConfig: async (data) => (await apiClient.post(API_ENDPOINTS.SOS.SAVE_PARTNER_CONFIG, data)).data,
};

export default sosService;

